export default "__VITE_ASSET__jDoDPIuq__"